import { useState, useEffect } from 'react';

export const useIsPhysicalTabletDetection = () => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const detectTablet = () => {
      const userAgent = navigator.userAgent;

      const isAndroidTablet = /Android(?!(.*(Mobile)))/i.test(userAgent);
      const isIPad = /iPad/i.test(userAgent);
      const isTablet = isAndroidTablet || isIPad
      
      setIsTablet(isTablet);
    };

    detectTablet();

    //Commenting this out. If this were a physical tablet it would never resize.
    // Keeping if for a while in case I decide to show the numeric keyboard based on dimensions to use it for desktop as well when size is between tablet and desktop.
    // window.addEventListener('resize', detectTablet);
    
    // return () => {
    //   window.removeEventListener('resize', detectTablet);
    // };
  }, []);

  return isTablet;
};
